import { lazy } from '../../shared/deployment';

export const EventDispatcherOnce = lazy(() => import('./EventDispatcherOnce'));
export const EventDispatcherOnUnmount = lazy(() => import('./EventDispatcherOnUnmount'));
export const VmEventListener = lazy(() => import('./VmEventListener'));
export const VmEventTimeout = lazy(() => import('./VmEventTimeout'));
